import { network } from 'services/network';

export const deleteDashboardById = (params) => {
    return network.post('api/bo/deleteDashboardById', params).then((response) => {
        return response.data;
    });
};
